import { Modal, Select, message, Row, Col, Card, Form } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { assignLogoToUser, deleteLogoFromUser } from '../../lib/userLogos';
import { useSelector } from 'react-redux';
import { DeleteOutlined } from '@ant-design/icons';

const SettingsModal = ({ visible, onClose, user, onAssignLogo }) => {
  const [selectedLogo, setSelectedLogo] = useState(null);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const { carHouseLogos } = useSelector((state) => state.carHouseLogos);

  const currentUserLogo = user?.logo;

  useEffect(() => {
    if (visible) {
      setSelectedLogo(null);
    }
  }, [visible]);

  const onLogoSelect = async (logoId) => {
    setSelectedLogo(logoId);
    setLoading(true);
    try {
      await assignLogoToUser(user.id, logoId);
      message.success(t('common.logoAssignedSuccessfully'));
      onClose();
      onAssignLogo(null);
    } catch (error) {
      const response = error.response.data;

      if (response?.description) {
        message.error(response.description);
      } else {
        message.error(t('common.failedToAssignLogo'));
      }
    } finally {
      setLoading(false);
    }
  };

  const onRemove = async () => {
    setLoading(true);
    try {
      await deleteLogoFromUser(user.id, user.logoId);
      message.success(t('common.logoRemoveSuccessfully'));
      onClose();
      onAssignLogo(null);
    } catch (err) {
      console.error(err);
      message.error(t('common.failedToRemoveLogo'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={`${t('common.logo')} ${user?.firstName || ''} ${user?.lastName || ''}`}
      open={visible}
      onCancel={onClose}
      footer={null}
    >
      <h2>{t('common.logo')}</h2>
      {currentUserLogo ? (
        <div style={{ marginBottom: '16px' }}>
          <Row align="middle" gutter={16}>
            <Col>
              <Card style={{ height: '100%', position: 'relative' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <img
                    src={currentUserLogo.path}
                    alt={currentUserLogo.name}
                    height={100}
                    width={100}
                    style={{ objectFit: 'contain' }}
                  />

                  <DeleteOutlined
                    style={{
                      position: 'absolute',
                      top: 8,
                      right: 8,
                      fontSize: 20,
                      color: 'var(--ant-error-color)',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      onRemove();
                    }}
                  />
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      ) : (
        <div style={{ marginBottom: '16px' }}>
          <strong>{t('common.noLogoAssigned')}</strong>
        </div>
      )}
      <Form layout="vertical">
        <Form.Item label={currentUserLogo ? t('common.changeLogo') : t('common.chooseLogo')}>
          <Select
            style={{ width: '100%' }}
            placeholder={t('common.selectLogo')}
            value={selectedLogo}
            onChange={onLogoSelect}
            allowClear
            showSearch
            filterOption={(input, option) =>
              option?.label?.props?.children
                ?.toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {carHouseLogos?.map((logo) => (
              <Select.Option
                key={logo.id}
                value={logo.id}
                label={
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                    }}
                  >
                    <img
                      src={logo.path}
                      alt={logo.name}
                      style={{
                        width: '30px',
                        height: '30px',
                        objectFit: 'contain',
                      }}
                    />
                    {logo.name}
                  </div>
                }
              >
                <Row align="middle" gutter={16}>
                  <Col>
                    <img
                      src={logo.path}
                      alt={logo.name}
                      style={{
                        width: '40px',
                        height: '40px',
                        objectFit: 'contain',
                      }}
                    />
                  </Col>
                  <Col style={{ fontSize: '16px' }}>{logo.name}</Col>
                </Row>
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SettingsModal;
